namespace Gamification.Gamification {
    export interface ApiOperazioniRow {
        IdApiOperazione?: number;
        IdApiTipoOperazione?: number;
        Nome?: string;
        Descrizione?: string;
        IdApiTipoOperazioneNome?: string;
        Area?: number;
    }

    export namespace ApiOperazioniRow {
        export const idProperty = 'IdApiOperazione';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ApiOperazioni';
        export const lookupKey = 'Gamification.ApiOperazioni';

        export function getLookup(): Q.Lookup<ApiOperazioniRow> {
            return Q.getLookup<ApiOperazioniRow>('Gamification.ApiOperazioni');
        }
        export const deletePermission = 'Role:Administrators';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdApiOperazione = "IdApiOperazione",
            IdApiTipoOperazione = "IdApiTipoOperazione",
            Nome = "Nome",
            Descrizione = "Descrizione",
            IdApiTipoOperazioneNome = "IdApiTipoOperazioneNome",
            Area = "Area"
        }
    }
}
